module.exports = __webpack_public_path__ + "img/6.dea46dec.png";